import api from 'services/api';
import { PromoCodeValidation } from './types';

export const validatePromoCode = ({ ticketTypesId, promoCode, partnerId }: PromoCodeValidation) =>
	api.post('/public/ticketing/promocodes/validate', {
		ticket_types: ticketTypesId.map(String),
		promocode_name: promoCode,
		partner_id: Number(partnerId),
	});
